import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {alertMessage} from "@app/constants/Messages";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {toast} from "react-toastify";
import Select from "react-select";
import {DVTJCUVPipelineInputMode} from "@pages/dvtjcuv/edit/DVTJCUVPipelineInputForm";
import {stringToOption} from "@app/utils/CommonUtils";
import { set } from 'lodash';

const EmailTypeOptions = [
    'N/A',
    'Email Công ty',
    'Email cá nhân',
].map(item => {
    return {value: item, label: item};
})

const InteractionNoteOptions = [
    '',
    'N/A',
    'check kỹ chất lượng UV'
].map(item => {
    return {value: item, label: item};
})

export const ReceiveRequestOptions = [
    '',
    'N/A',
    'Không gửi bất cứ UV nào',
    'Gửi UV có đặc điểm nhất định',
    'Gửi UV theo tuần',
    'Gửi UV theo tháng',
    'Các yêu cầu đặc biệt khác vv gửi UV'
].map(item => {
    return {value: item, label: item};
})

export const ReceiverCategoryOptions = [
    '',
    'N/A',
    'Quan tâm ƯV nhưng không chịu share job',
    'Tạm dừng send',
].map(item => {
    return {value: item, label: item};
})

const BDEmailRequestOptions = [
    '',
    'N/A',
    'không nhận',
    'nhận theo tháng',
    'nhận theo quý',
    'Các yêu cầu đặc biệt khác vv nhận email BD'
].map(item => {
    return {value: item, label: item};
})

export const ContactPointFields = [
    {key: 'email_type', label: 'Loại email prefer', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: EmailTypeOptions},
    {key: 'interaction_note', label: 'Lưu ý khi tương tác', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: InteractionNoteOptions, color: ''},
    {key: 'candidate_receive_request', label: 'Yêu cầu nhận UV (DVTJCUV)', classNames: '', displayType: 'text', inputType: 'option', editable: true, isMulti: true, autoAdd: false, options: ReceiveRequestOptions, capitalize: false},
    {key: 'cdd_receiver_category', label: 'Phân loại as a Cdd Receiver', classNames: '', displayType: 'text', inputType: 'option', editable: true, isMulti: true, autoAdd: false, options: ReceiverCategoryOptions, capitalize: false},
    {key: 'bd_email_request', label: 'Yêu cầu vv nhận email BD', classNames: '', displayType: 'text', inputType: 'option', editable: true, autoAdd: false, options: BDEmailRequestOptions, capitalize: false},
    {key: 'contact_point_note', label: 'Note as a Contact Point/Hiring Mgr', classNames: '', displayType: 'text', inputType: 'text', editable: true, autoAdd: false, capitalize: false},
];

const InitData = {
}

const CandidateContactPoints = (props) => {
    const [contactPoints, setContactPoints] = useState({});
    const [isEdit, setEdit] = useState(false);
    const [isLoading, setIsLoading] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])
    const {
        candidateId,
        mode = 'Edit',
        initContactPoint,
        onChange,
        onSave,
        isEditContactPoint

    } = props

    useEffect(() => {
        setEdit(isEditContactPoint);
        setContactPoints({...initContactPoint});
    }, [isEditContactPoint, initContactPoint]);

    const displayContactPoints = (inputData) => {
        const output = {...inputData}
        ContactPointFields.forEach(column => {
            if (column.inputType === 'option') {
                output[column.key] = stringToOption(inputData[column.key], column.isMulti);
            }
        })
        setContactPoints(output)
    }

    const fetchContactPoints = async (canId) => {
        setIsLoading(true)
        const res = await CandidateService.getContactPointDetail(canId)
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            displayContactPoints(res.content.contact_points)
        } else {
            alertMessage(res.sts_code)
            setContactPoints(InitData)
        }
    };

    const updateContactPoints = async () => {
        setIsLoading(true)
        const res = await CandidateService.updateContactPointDetail({
            candidate_id: candidateId,
            contact_points: contactPoints,
        })

        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            setEdit(false)
        } else {
            toast.error(`Lưu thông tin thất bại`);
        }
    };

    useEffect(() => {
        console.log("fetchCandidateGeneral")
        if (candidateId) {
            fetchContactPoints(candidateId)
        }
    }, [])

    const onChangeInput = (value, column) => {
        contactPoints[column.key] = value
        setContactPoints({...contactPoints})

        if (onChange) {
            onChange(contactPoints);
        }
    }

    const getOptions = (column) => {
        return column.options
    }

    const disableColumn = (column) => {
        if (!column.editable || !isEdit) {
            return true
        }

        return false
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Notes</h3>
                {mode !=='Search' &&
                <div className='card-tools'>
                    {isEdit &&
                        <>
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setEdit(false);
                                    }}
                            >
                                Cancel
                            </button>
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => updateContactPoints()}
                            >
                                Save
                            </button>
                        </>
                    }
                    {!isEdit &&
                        <button type='button'
                                className='btn btn-default'
                                onClick={() => {
                                    setEdit(true);
                                }}
                        >
                        Edit
                    </button>
                    }
                </div>
                }
            </div>
            <div className='card-body'>
                {ContactPointFields.map(column => {
                    if (column.inputType === 'option') {
                        return <div className='col-sm-12' key={`ContactPointFields_item_${column.key}`}>
                            <div className='form-group'>
                                <div style={{width: '100%'}}>
                                    <label className={`w-100`}>{column.label}</label>
                                    <Select options={getOptions(column)}
                                            value={getItemValues(column, contactPoints[column.key])}
                                            isDisabled={!column.editable || !isEdit}
                                            name={column.key}
                                            isMulti={!!column.isMulti}
                                            onChange={value => {
                                                onChangeInput(value, column);
                                            }}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    return <div className='col-sm-12' key={`ContactPointFields_item_${column.key}`}>
                        <div className='form-group'>
                            <label className={'w-100'}>{column.label}</label>
                            <input type={column.inputType} className='form-control'
                                   disabled={disableColumn(column)}
                                   value={contactPoints[column.key] || ''}
                                   name={column.key}
                                   onChange={event => onChangeInput(event.target.value, column)}/>
                        </div>
                    </div>
                })}

            </div>
        </div>
    )
}

export default CandidateContactPoints;
